import type { BillingPreviewComboMode } from "@/domain/cart/billing-preview.types"

/**
 * Resolves combo payload shape for billing preview. **API / transport layer only** —
 * pass the result into `transformCartToBillingPreviewCartItems` as `comboMode` (transformer stays pure).
 *
 * - **structural** (default): `combos[]` on the parent line.
 * - **legacy:** extra preview rows per combo child (`client_item_id` contains `:combo:`).
 *
 * Legacy: `REACT_APP_BILLING_PREVIEW_LEGACY_COMBO_ROW_EXPANSION=true`
 */
export function resolveBillingPreviewComboMode(): BillingPreviewComboMode {
  const legacy =
    String(process.env.REACT_APP_BILLING_PREVIEW_LEGACY_COMBO_ROW_EXPANSION ?? "").toLowerCase() === "true"
  return legacy ? "legacy" : "structural"
}
